import React, { useState, useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import '../styles/views/projects-catalog.css';

const normalizeSector = (value) => value === 'museum' ? 'expography' : value;

export default function ProjectsCatalog({ onNavigate, initialSector }) {
  const [sector, setSector] = useState(normalizeSector(initialSector || 'all'));

  useEffect(() => {
    if (initialSector) setSector(normalizeSector(initialSector));
  }, [initialSector]);

  const { data, isLoading } = useQuery({
    queryKey: ['projects', sector],
    queryFn: async () => {
      const url = sector === 'all' ? '/api/projects' : `/api/projects?sector=${sector}`;
      const res = await fetch(url);
      return res.json();
    }
  });

  const projects = data?.projects || [];

  return (
    <div className="section">
      <div className="catalog__header">
        <p className="font-label catalog__eyebrow">
          PORTFÓLIO DE PROJETOS
        </p>
        <h1 className="font-display catalog__title">
          Obras Selecionadas
        </h1>

        {/* Sector Filter Tabs */}
        <div className="catalog__filters">
          {[
            { id: 'all', label: 'Todos os Projetos' },
            { id: 'residential', label: 'Residencial' },
            { id: 'expography', label: 'Expografia' },
            { id: 'commercial', label: 'Comercial' }
          ].map((tab) => (
            <button
              key={tab.id}
              onClick={() => setSector(tab.id)}
              className={`catalog__tab ${sector === tab.id ? 'is-active' : ''}`}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {isLoading ? (
        <p className="loading-note">Carregando projetos...</p>
      ) : projects.length === 0 ? (
        <p className="loading-note">Nenhum projeto encontrado neste setor.</p>
      ) : (
        <div className="catalog__grid">
          {projects.map((proj) => (
            <div
              key={proj.id}
              onClick={() => onNavigate(`/projects/${proj.slug}`)}
              className="catalog-card"
            >
              <div className="catalog-card__media">
                <img
                  src={proj.cover_image}
                  alt={proj.title}
                  className="catalog-card__img"
                />
              </div>
              <div className="catalog-card__meta">
                <span className="font-label catalog-card__sector">
                  {proj.sector === 'museum' || proj.sector === 'expography' ? 'EXPOGRAFIA' : proj.sector.toUpperCase()}
                </span>
                <span className="font-label catalog-card__year">
                  {proj.year || new Date(proj.created_at).getFullYear()}
                </span>
              </div>
              <h3 className="font-display catalog-card__title">
                {proj.title}
              </h3>
              {proj.city && <p className="catalog-card__city">{proj.city}</p>}
              <p className="catalog-card__summary">
                {proj.summary}
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
